import styled from 'styled-components';
import { Text } from '@perch-labs/shrike';
import { Container } from 'styles';

export const LinkBackdrop = styled(Container)`
  background-color: ${props => props.theme.colors.background.secondary};
  border-radius: 8px;
  padding: 24px;
`;

export const LinkText = styled(Text).attrs({ textStyle: 'paragraph400' })`
  margin-right: 32px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
